import type { Insurance, InsuranceApiResponse } from './index'

export const mapInsuranceApiResponse = (response: InsuranceApiResponse): Insurance | null => {
  const attributes = response.section?.items?.[0]?.attributes

  if (!attributes) {
    return null
  }

  return {
    ...attributes,
    eligibility: response.eligibility,
  }
}
